export default {
  RTP_WAITING: '0',
  // 01/03/2023 DDE mise à jour de la liste des statuts RTP
  // ----------NOUVEAUX STATUTS
  RTP_ISSUED: '1',
  RTP_ACCEPTED: '10',
  RTP_REJECTED: '6',
  RTP_RECEIVED: '5',
  RTP_REVOKED: '11',
  RTP_EXPIRED: '12',
  RTP_MODIFIED: '9',
  // ----------ANCIENS STATUTS
  // RTP_REVOKED: '3',
  RTP_ORDER_GENERATED: '21',
  RTP_ORDER_SENT: '22',
  RTP_ORDER_NOT_SENT: '23',
  RTP_ORDER_VALIDATED: '24',
  RTP_ORDER_REJECTED: '25',
  RTP_MADE: '26',
  RTP_INSTALLMENT_PAID: '30',
  RTP_INST_ORDER_GENERATED: '31',
  RTP_INST_PAYMENT_SENT: '32',
  RTP_INST_PAYMENT_NOT_SENT: '33',
  RTP_INST_PAYMENT_VALIDATED: '34',
  RTP_INST_PAYMENT_REJECTED: '35',
  RTP_INST_MADE: '36',
  RTP_CANCELED: '8',
  RTP_MSG_FORMAT_INCORRECT: '7',
  // RTP_EXPIRED: '9',
  // RTP_ACCEPTED_AND_PAYED: '10',
  // RTP_ACCEPTED_AND_PAYED_INST: '11',
  RTP_MODIFIED_AND_PAYED: '13',
  RTP_MODIFIED_AND_PAYED_INST: '14',
  // RTP_REJECTED: '15',
  // RTP_RECEIVED: '16',
  RTP_CANCELED_CONFIRM: '17',
  RTP_CANCELED_ABORT: '18',
  RTP_INFORMATION: '20',

  WAITING_DECISION: 'pain008_4', // Traitement en cours, réponses Lucy complètement reçues
  FILE_REFUSED: 'pain008_3',
  PROCESSED_PENDING: 'pain008_1', //Enregistrement en cours
  PROCESS_REGISTERED: 'pain008_2', //Enregistré
  // PROCESSED_RETURNED_IMME: 'pain008_2',
  FINISH: 'pain008_5', // Terminé
  STATE_CLOSED: 'pain008_6', // Clos, n'apparait que pour statut 5
  // PARTIALLY_TREATY: 'pain008_7',
  LOCK: 'pain008_99', //ne se verra jamais en IHM
  POSITIVE_RESPONSE: 'pain008_10',
  NEGATIVE_RESPONSE: 'pain008_11',
  RIB_ANOMALY: 'pain008_50',
  BANK_UNREACHABLE: 'pain008_8',
  EXPIRED_REQUEST: 'pain008_12',
  REQUEST_BEING_PROCESSED: 'pain008_52',
  ELIGIBLE_RECONSTRUCTION: 'pain008_98',

  P_ACCP: 'pacs008_1',
  P_RJCT: 'pacs008_2',
  P_DEFAULT: 'pacs008_0',
  P_PROCESSED: 'pacs008_05',
  P_WAITING: 'pacs008_01',
  P_WAITING_INST: 'pacs008_02',
  P_CANCEL_SAVE: 'pacs008_013',
  P_CANCEL: 'pacs008_014',
  P_RECALL_SAVE: 'pacs008_016',
  P_RECALL: 'pacs008_017',
  P_RETURN_SAVE: 'pacs008_019',
  P_RETURN: 'pacs008_020',
  P_RECEPTION: 'reception',
  P_EMISSION: 'emission',

  NOT_CLOSED_FOLDER: 'Folder_30',
  CLOSED_FOLDER: 'Folder_31',
  FOLDER_CONTAINING_EXPIRED: 'Folder_32',
  FOLDER_CONTAINING_REFUSED: 'Folder_33',

  NOT_CLOSED_PAYMENTGROUP: 'PaymentGroup_30',
  CLOSED_PAYMENTGROUP: 'PaymentGroup_31',
  PAYMENTGROUP_CONTAINING_EXPIRED: 'PaymentGroup_32',
  PAYMENTGROUP_CONTAINING_REFUSED: 'PaymentGroup_33',

  PROVIDER_INITIALIZED: 'Provider_0',
  PROVIDER_OPEN: 'Provider_1',
  PROVIDER_VALIDATED: 'Provider_2',
  PROVIDER_NOT_VALIDATED: 'Provider_3',
  PROVIDER_THIRD_PARTY_SENT: 'Provider_10',
  PROVIDER_THIRD_PARTY_VALIDATED: 'Provider_11',
  PROVIDER_THIRD_PARTY_REJECTED: 'Provider_12',
  PROVIDER_TO_REFRESH: 'Provider_20',
  PROVIDER_CLOSED: 'Provider_31',
  PROVIDER_VALIDATED_AND_CLOSED: 'Provider_32',

  SELLER_INITIALIZED: 'Seller_0',
  SELLER_NOT_CLOSED: 'Seller_1',
  SELLER_CLOSED: 'Seller_2',
  SELLER_REVOKED: 'Seller_3',

  DOC_INITIALIZED: 'Doc_0',
  DOC_REQUEST_SENT: 'Doc_1',
  DOC_REQUEST_RECEIVED: 'Doc_2',
  DOC_REQUEST_REJECTED: 'Doc_3',
  DOC_REQUEST_CANCELED: 'Doc_4',
  DOC_REQUEST_OUT_TIME: 'Doc_5',
  DOC_REQUEST_ACCEPTED: 'Doc_6',
  DOC_REQUEST_REFUSED: 'Doc_7',
  DOC_REQUEST_READ: 'Doc_8',
  DOC_SENT: 'Doc_10',
  DOC_RECEIVED: 'Doc_11',
  DOC_REJECTED: 'Doc_12',
  DOC_VALIDATED: 'Doc_13',
  DOC_REFUSED: 'Doc_14',
  DOC_EXPIRED: 'Doc_15',
  DOC_VALIDATED_MAN: 'Doc_16',
  DOC_READ: 'Doc_18',
  DOC_CANCELED: 'Doc_19',
  DOC_NEGOTIATION_SENT: 'Doc_20',
  DOC_NEGOTIATION_RECEIVED: 'Doc_21',
  DOC_NEGOTIATION_ACCEPTED: 'Doc_22',
  DOC_NEGOTIATION_REVOKED: 'Doc_23',
  DOC_THIRD_PARTY_SENT: 'Doc_30',
  DOC_THIRD_PARTY_RECEIVED: 'Doc_31',
  DOC_THIRD_PARTY_REJECTED: 'Doc_32',
  DOC_THIRD_PARTY_VALIDATED: 'Doc_33',
  DOC_THIRD_PARTY_REFUSED: 'Doc_34',
  DOC_CLOSING: 'Doc_40',
  DOC_CLOSED: 'Doc_41',
  DOC_PAID: 'Doc_99',

  KYCSTEP_CREATED: 'Doc_101',
  KYCSTEP_WAITING: 'Doc_102',
  KYCSTEP_VALIDATED: 'Doc_103',
  KYCSTEP_VALIDATED_MAN: 'Doc_104',
  KYCSTEP_REJECTED: 'Doc_105',
  KYCSTEP_EXPIRED: 'Doc_106',

  KYCVERIFICATIONS_VALID: 'KYCVerifications_1',
  KYCVERIFICATIONS_INFO: 'KYCVerifications_2',
  KYCVERIFICATIONS_WARNING: 'KYCVerifications_3',
  KYCVERIFICATIONS_ERROR: 'KYCVerifications_4',

  DRAFT_NEED_COMPLETED: 'Draft_1',
  DRAFT_WAITING_VALIDATION: 'Draft_2',
  DRAFT_WAITING_UPPER_VALIDATION: 'Draft_3',
  DRAFT_READY_TO_SEND: 'Draft_4',

  INVOICE_CREATED: 'Invoice_0',
  INVOICE_PAYMENT_INITIALIZED: 'Invoice_1',
  INVOICE_TRANSFER_INITIALIZED: 'Invoice_2',
  INVOICE_PAYMENT_DONE: 'Invoice_3',
  INVOICE_PARTIAL_PAYMENT: 'Invoice_4',
  INVOICE_TOTAL_PAYMENT: 'Invoice_5',
  INVOICE_COMMISSION_PAYMENT_INITIALIZED: 'Invoice_6',
  INVOICE_VENDOR_PAYMENT_INITIALIZED: 'Invoice_7',
  INVOICE_COMMISSION_PAYMENT_CONFIRMED: 'Invoice_8',
  INVOICE_VENDOR_PAYMENT_CONFIRMED: 'Invoice_9',
  INVOICE_ERROR: 'Invoice_10',
  INVOICE_CB_ERROR: 'Invoice_11',

  TRANSACTION_RECEIVED: 'Transaction_0',
  TRANSACTION_NO_MATCH: 'Transaction_1',
  TRANSACTION_AMBIGUOUS: 'Transaction_2',
  TRANSACTION_LINKED: 'Transaction_3',
  TRANSACTION_ALLOCATED: 'Transaction_4',
  TRANSACTION_VENTILATION: 'Transaction_5',
  TRANSACTION_IGNORED: 'Transaction_6'

}
